var map = {
	"./DoubtForum.svg": [
		94288,
		4288
	],
	"./Email.svg": [
		37635,
		7635
	],
	"./Feedback.svg": [
		45600,
		5600
	],
	"./MyAchievements.svg": [
		9055,
		9055
	],
	"./MyBooks.svg": [
		65359,
		5359
	],
	"./MyDashboard.svg": [
		12453,
		2453
	],
	"./MyLiveClasses.svg": [
		88243,
		8243
	],
	"./MyPurchase.svg": [
		35770,
		5770
	],
	"./MyPurchase1.svg": [
		33111,
		3111
	],
	"./MyStudyMaterials.svg": [
		86980,
		6980
	],
	"./MyTestSeries.svg": [
		30516,
		516
	],
	"./MyVideoCourses.svg": [
		16910,
		6910
	],
	"./MyWallet.svg": [
		15952,
		5952
	],
	"./TimeTable.svg": [
		47698,
		7698
	],
	"./acheivment1.svg": [
		56146,
		6146
	],
	"./achivmentsfolder/instgram.svg": [
		14517,
		4517
	],
	"./achivmentsfolder/linkdin.svg": [
		9597,
		9597
	],
	"./achivmentsfolder/youtubeicon.svg": [
		87168,
		7168
	],
	"./bookz.svg": [
		24164,
		4164
	],
	"./connections.svg": [
		44536,
		4536
	],
	"./copy.svg": [
		12270,
		2270
	],
	"./course.svg": [
		52394,
		2394
	],
	"./currentAffairs.svg": [
		9914,
		9914
	],
	"./ebooks.svg": [
		27812,
		7812
	],
	"./emojiicon.svg": [
		76890,
		6890
	],
	"./feedbackicon1.svg": [
		92816,
		2816
	],
	"./fileicon.svg": [
		90288,
		288
	],
	"./filtericon.svg": [
		47360,
		7360
	],
	"./girlIMG.svg": [
		848,
		848
	],
	"./helpdesk.svg": [
		60715,
		715
	],
	"./logo.svg": [
		36572,
		6572
	],
	"./logout.svg": [
		53415,
		3415
	],
	"./myachivment.svg": [
		81084,
		1084
	],
	"./next.svg": [
		87134,
		7134
	],
	"./playbtn.svg": [
		60761,
		761
	],
	"./pyp.svg": [
		24040,
		4040
	],
	"./referAndEarnNew.svg": [
		84480,
		4480
	],
	"./referandearn.svg": [
		17138,
		7138
	],
	"./resellbooks.svg": [
		62292,
		2292
	],
	"./resumeicon.svg": [
		40011,
		11
	],
	"./sendicon.svg": [
		11560,
		1560
	],
	"./seperatepanel.svg": [
		8992,
		8992
	],
	"./setting.svg": [
		23099,
		3099
	],
	"./share.svg": [
		15262,
		5262
	],
	"./startovericon.svg": [
		94342,
		4342
	],
	"./tableheadvector.svg": [
		88744,
		8744
	],
	"./trophyicon.svg": [
		97872,
		7872
	],
	"./videocourse1.svg": [
		49754,
		9754
	],
	"./wallet.logo.svg": [
		69973,
		9973
	],
	"./walletimage.svg": [
		77265,
		7265
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 38969;
module.exports = webpackAsyncContext;